import Icon from '../components/Icon.vue'

Icon.register({
  'pizza-slice': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M158.9 0.1c181.9 17.2 332 164.9 352.9 345.7 1.9 16.2-7.9 31.5-23.6 35.9l-56.9 15.8c-7.9-186.4-134.9-311.5-322.5-317l14.8-56.3c4.1-15.7 19.2-25.6 35.3-24.1zM100.4 112.1c176.1 2 294.9 119.3 299.1 294.1l-379 105.1c-1.2 0.3-3.1 0.6-4.3 0.6-8.9 0-16.2-7.3-16.2-16.2 0-1.2 0.2-3 0.5-4.1zM128 416c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM176 264c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM280 368c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})
